import ApiBase from "../../../../bans/services/Api"

export default class Api {
    static bindBan(query) {
        return ApiBase.bindBan(query).then((resp) => {
            return resp.data
        })
    }
}
